import React, { useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap"
import { useDrop } from "react-dnd";
import DraggableContainer from "./SalesDraggableContainer";
import Tooltip from "rc-tooltip";

// Constants
import colors from "../../../utils/colors";
import items from "../../../utils/items";

// Images
import productPlaceholder from "../../../assets/images/product-placeholder.png"
import { useDispatch } from "react-redux";
import {
	openContainerProperties
} from "../../../Redux/dispatchers";

export default function SalesDroppableField(props) {
	const [isHover, setIsHover] = useState(false);

	const [{ isOver, canDrop }, drop] = useDrop({
		accept: [items.productionContainer],
		collect: (monitor) => {
			return {
				isOver: monitor.isOver(),
				canDrop: monitor.getItem()?.cardValue ? monitor.canDrop() : false,
			}
		},
		drop: (item) => {
			props.appendContainer(item.coins, props.id, item.hasCard, item.cardValue, item.cardColor);
			return item;
		},
	});

	const backgroundColor = isOver && canDrop ? colors.activeBackground : "";
	const opacity = props.design ? 0.5 : 1;
	const canPlayerDrop = canDrop ? drop : null;

	// Restored board state can contain null entries for some fields -
	// fall back to an empty object instead of crashing the whole board.
	const data = props.data || {};

	let showTooltip = data.isDragging && data.type === "CONTAINER" ? true : false;
	if (!showTooltip) {
		if (isHover && window.playerId) {
			showTooltip = true;
		}
	} else if (data.playerId === window.playerId) {
		showTooltip = false;
	}

	const dispatch = useDispatch();

	const showContainerProperties = () => {
		console.log("SalesDroppableField showContainerProperties props: ", props.id, props.mainId);
		if (data.hasContainer)
			dispatch(openContainerProperties("FIELD", "Sales", props.id, props.mainId));
	};
	return (
		<>
			{data.hasContainer ? (
				<div
					className={props.class}
					onMouseEnter={() => setIsHover(true)}
					onMouseLeave={() => setIsHover(false)}
					onClick={showContainerProperties}
				>
					<Tooltip
						placement="topRight"
						align={{
							offset: [0, 5],
						}}
						visible={showTooltip}
						overlay={
							<div style={{ display: "flex", flexDirection: "column" }}>
								<span>{data.coins?.reduce((acc, coin) => acc + coin, 0)} Coins</span>
							</div>
						}
					>
						<DraggableContainer
							id={props.id}
							canEdit={props.canEdit}
							data={data}
							isHorizontal={props.isHorizontal}
							containerType={props.containerType}
							productionType={props.productionType}
							removeContainer={props.removeContainer}
							addCoin={props.addCoin}
							removeCoin={props.removeCoin}
							addCard={props.addCard}
							isDraggingHandler={props.isDraggingHandler}
							kind={props.kind}
							pinId={props.mainId}
						/>
					</Tooltip>
				</div>
			) : (
				<div
					className={props.class}
					style={{ backgroundColor: backgroundColor, opacity: opacity }}
					ref={canPlayerDrop}
				>
					{
						(props.productionType === "product" && <div className="field-content">
							<Container>
								<Row className="field-content-image-row product">
									<Col>
										<Image src={productPlaceholder} />
									</Col>
								</Row>
							</Container>
						</div>)
					}
				</div>
			)}
		</>
	);
}
